import { render, staticRenderFns } from "./BuildAssignment.vue?vue&type=template&id=07d58376&"
import script from "./BuildAssignment.vue?vue&type=script&lang=js&"
export * from "./BuildAssignment.vue?vue&type=script&lang=js&"
import style0 from "./BuildAssignment.vue?vue&type=style&index=0&id=07d58376&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports